import React from "react";
import { Paragraph, Text } from "components/core/Typography";

const MailingAddress = () => (
	<>
		<Text
			weight="bold"
			size="xxlarge"
		>
			Mailing Address:
		</Text>
		<Text>
			<Paragraph
				weight="bold"
				size="medium"
				last
			>
				Storage.com
			</Paragraph>
			<Paragraph
				size="standard"
				last
			>
				10900 Research Blvd 160C PMB 3099
			</Paragraph>
			<Paragraph size="standard"> Austin, TX 78759</Paragraph>
		</Text>
	</>
);

export default MailingAddress;
